import { Field, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState, usecity } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import CustomInput from '../../../components/common/CustomInput'
import CustomSelect from '../../../components/common/CustomSelect'
import toast from 'react-hot-toast'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  city: Yup.string().trim().required('City is required'),
  state: Yup.string().trim().required('State is required'),
  pincode: Yup.string().trim().required('Pincode is required'),
})

function Edit() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [stateOptions, setStateOptions] = useState([])

  const fetchStateData = async () => {
    try {
      const response = await axiosAuthInstance.get('state/dropdown')
      if (response.status === 200) {
        const transformedData = response?.data?.result?.map((item) => ({
          value: item._id,
          label: item.name,
        }))
        setStateOptions(transformedData)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchStateData()
  }, [])

  const formik = useFormik({
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
    validationSchema: validationSchema,
    initialValues: {
      city: '',
      state: '',
      pincode: '',
    },
  })

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get(`city/detail/${id}`)
      formik.setValues({
        city: response.data.result.name,
        state: response.data.result.state._id,
        pincode: response.data.result.pincode,
      })
      setLoading(false)
    } catch (error) {
      console.log('error in fetching edit data: ', error)
    }
  }
  useEffect(() => {
    fetchData()
  }, [id])

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = await axiosAuthInstance.put(`city/update/${id}`, {
        name: values.city,
        state: values.stateId,
        pincode: values.pincode,
      })
      if (response) {
        navigate('/city')
      }
    } catch (error) {
      console.log(error)
    }
  }

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name='city'
          label='city'
          placeholder='Enter city'
          required
          component={CustomInput}
        />
        <Field
          name='state'
          label='State'
          placeholder='State'
          required
          component={CustomSelect}
          options={stateOptions}
        />
        <Field
          name='pincode'
          label='Pincode'
          placeholder='Enter Pincode'
          required
          component={CustomInput}
        />
        <button
          type='submit'
          disabled={formik.isSubmitting}
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          Update
        </button>
      </form>
    </FormikProvider>
  )
}

export default Edit
